import {
  DateValue,
  SurveyQuestionAnswer,
  SurveyQuestionTypeOptions,
} from '@chiroup/core/types/Survey.type';
import React, { useCallback, useState } from 'react';
import { HCDatepicker } from '../datepicker/HCDatepicker';
import { questionContentVerbiage } from './SurveyQuestionContent';

type Props = {
  dateOptions?: SurveyQuestionTypeOptions;
  onSelect: (val: SurveyQuestionAnswer) => Promise<void>;
  disabled?: boolean;
  hideNext?: boolean;
  language?: string;
  primaryColor?: string;
  size?: 'normal' | 'small';
  hideSelectedMessage?: boolean;
};

export const SurveyQuestionDate: React.FC<Props> = ({
  dateOptions,
  onSelect,
  disabled,
  hideNext = false,
  language = 'en',
  primaryColor,
  size = 'normal',
  hideSelectedMessage = false,
}) => {
  const [val, setVal] = useState<DateValue>();

  // Size-based styling variables
  const containerTextSize = size === 'small' ? 'text-lg sm:text-xl' : 'text-xl sm:text-2xl';
  const buttonPadding = size === 'small' ? 'px-3 py-2' : 'px-5 py-3';
  const buttonTextSize = size === 'small' ? 'text-sm' : 'text-base';

  const onChange = useCallback(
    async (e?: DateValue) => {
      setVal(e);

      if (e && hideNext) {
        console.error({ e });
        await onSelect({ type: 'date', value: e });
        setVal(undefined);
      }
    },
    [hideNext, onSelect]
  );

  const handleSubmit = async () => {
    if (val) {
      await onSelect({ type: 'date', value: val });
      setVal(undefined);
    }
  };

  return (
    <div className="flex justify-center">
      <fieldset className={`mt-6 ${containerTextSize} font-medium text-gray-500`}>
        <div className="mt-4">
          <HCDatepicker
            options={dateOptions}
            onChange={onChange}
            primaryColor={primaryColor || '#93cc68'}
            language={language}
            size={size}
            hideSelectedMessage={hideSelectedMessage}
          />
          {!hideNext && (
            <button
              disabled={!val || disabled}
              onClick={handleSubmit}
              className={`cursor-pointer rounded-md shadow items-center justify-center ${buttonPadding} border border-transparent ${buttonTextSize} font-medium text-white hover:opacity-90 focus:outline-none focus:ring transition duration-150 ease-in-out mt-4`}
              style={{
                backgroundColor: primaryColor,
              }}
              data-cy="next-button"
            >
              {questionContentVerbiage[language === 'es' ? 'es' : 'en'].next}
            </button>
          )}
        </div>
      </fieldset>
    </div>
  );
};
